import * as React from "react";
import { Checkbox, FormControlLabel, Box, Typography } from "@mui/material";
import CollapsibleTable from "./CollapsibleTable";
import GenericTable from "./GenericTable";
import { transformFiltersForUrl } from "../../utils/transformFiltersForUrl";
import { useEffect } from "react";
import { useState } from "react";
import { formatDatesInObject } from "../../utils/formatDate";

export default function TableWithInactiveFilter({
  data,
  columns,
  collapseConfig,
  actions = [],
  totalPages = 1,
  currentPage = 0,
  onPageChange = () => {},
  filterValues,
  applyUrlFilters,
  localFilterValues,
  type = "collapse", // default = collapse
  rowsPerPage = 10,
  onRowsPerPageChange = () => {},
  showFilterInactive = false,
  showActions = true,
  defaultCollapseOpen = false,
  quantitySpaces = 1,
  rowColorConfig,
  isLoading = false, // Primeiro carregamento
  isFetching = false, // Refetch (paginação/filtro)
  expandedRowId = null,
  renderExpandedRow,
}) {
  const [checked, setChecked] = React.useState(
    filterValues?.deleted_at === true,
  );

  React.useEffect(() => {
    setChecked(filterValues?.deleted_at === true);
  }, [filterValues?.deleted_at]);

  const [formattedData, setFormattedData] = useState([]);

  // Use useEffect para formatar a data
  useEffect(() => {
    if (data && data.length > 0) {
      // Chama a função utilitária que percorre o objeto e formata as datas.
      const processedData = formatDatesInObject(data);
      setFormattedData(processedData);
    } else {
      // Limpa os dados se a prop 'data' estiver vazia ou nula.
      setFormattedData([]);
    }
  }, [data]);

  const handleStatusChange = () => {
    const newDeletedAtValue = !checked;
    setChecked(newDeletedAtValue);

    const newFilterValues = {
      ...localFilterValues,
      deleted_at: newDeletedAtValue,
    };

    applyUrlFilters(transformFiltersForUrl(newFilterValues));
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: showFilterInactive ? "space-between" : "flex-end",
        }}>
        {showFilterInactive && (
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleStatusChange}
                color="primary"
              />
            }
            label="Mostrar Excluídos"
          />
        )}

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#858484" }}
            align="right">
            Total: {data.length}
          </Typography>
        </Box>
      </Box>

      {type === "collapse" ? (
        <CollapsibleTable
          data={formattedData}
          columns={columns}
          collapseConfig={collapseConfig}
          actions={actions}
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          showActions={showActions}
          defaultOpen={defaultCollapseOpen}
          quantitySpaces={quantitySpaces}
          rowColorConfig={rowColorConfig}
          isLoading={isLoading}
          isFetching={isFetching}
        />
      ) : (
        <GenericTable
          data={formattedData}
          columns={columns}
          actions={actions}
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          rowColorConfig={rowColorConfig}
          isLoading={isLoading}
          isFetching={isFetching}
          expandedRowId={expandedRowId}
          renderExpandedRow={renderExpandedRow}
        />
      )}
    </>
  );
}
